// ============================================================
// experience_metadata_adapter.js
//
// Purpose:
// - Normalize industry Experience manifest metadata
// - Provide generic Experience metadata contract
// - Validate generated Experience metadata
//
// Features:
// - Supports any industry manifest
// - Keeps industry behavior outside core runtime
// - Provides validation diagnostics
// - Provides normalized metadata output
// ============================================================



// ============================================================
// adaptExperienceManifest
//
// Purpose:
// - Convert an industry manifest into a generic metadata
//   contract consumed by Experience Factory.
//
// Input:
// - manifest object
//
// Output:
// {
//   experienceType,
//   audience,
//   narrative,
//   branding,
//   objectives,
//   sourceManifest
// }
// ============================================================

export function adaptExperienceManifest(
  manifest
) {

  if (
    !manifest
  ) {

    throw new Error(
      "[Experience Metadata Adapter] Missing manifest."
    );

  }


  const experience =
    manifest.experience ?? {};


  const metadata = {

    // ========================================================
    // Generic Experience Identity Contract
    //
    // Purpose:
    // - Preserve industry routing information
    // - Support generated Experience validation
    // - Avoid industry-specific consumers
    // ========================================================

    industryKey:
      manifest.key ?? null,


    label:
      manifest.label ?? null,


    type:
      experience.experienceType ??
      manifest.experienceType ??
      null,


    scoring:
      manifest.scoring ?? null,

    experienceType:
      experience.experienceType ??
      manifest.experienceType ??
      null,


    audience:
      experience.demoAudience ??
      null,


    narrative:
      experience.demoNarrative ??
      null,


    branding:
      experience.branding ??
      null,


    objectives:
      experience.objectives ??
      [],


    sourceManifest:
      manifest,

  };


  console.log(
    "[Experience Metadata Adapter] Normalized metadata:",
    metadata
  );


  return metadata;

}



// ============================================================
// validateExperienceMetadata
//
// Purpose:
// - Verify normalized metadata contract.
//
// Returns:
// {
//   valid,
//   errors,
//   warnings
// }
// ============================================================

export function validateExperienceMetadata(
  metadata
) {

  const errors = [];

  const warnings = [];


  if (
    !metadata
  ) {

    return {

      valid:false,

      errors:[
        "Metadata object is missing."
      ],

      warnings:[]

    };

  }



  if (
    !metadata.experienceType
  ) {

    errors.push(
      "Missing experience type."
    );

  }



  if (
    !metadata.sourceManifest
  ) {

    errors.push(
      "Missing source manifest."
    );

  }



  if (
    !metadata.audience
  ) {

    warnings.push(
      "Experience audience metadata missing."
    );

  }



  if (
    !metadata.narrative
  ) {

    warnings.push(
      "Experience narrative metadata missing."
    );

  }



  const result = {

    valid:
      errors.length === 0,


    errors,


    warnings

  };


  console.log(
    "[Experience Metadata Adapter] Validation result:",
    result
  );


  return result;

}